<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t("catalogue.tab.dispositif") }}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <parametre-autocomplete
            v-model="produitDispositif.dispositifSupportId"
            :label="$t('catalogue.newProduct.dispositifSupport')"
            :target="constantes.PARAMETRES_KEYS.dispositifSupport"
            class="column is-3"
            required
            expanded
          />
          <div class="column is-3">
            <parametre-autocomplete
              :label="$t('catalogue.newProduct.typeDispositif')"
              v-model="produitDispositif.dispositifTypeId"
              :target="constantes.PARAMETRES_KEYS.dispositifType"
            />
          </div>
          <div class="column is-3">
            <parametre-autocomplete
              :label="$t('materiel.format.format')"
              v-model="produitDispositif.materielFormatId"
              :target="constantes.PARAMETRES_KEYS.materielFormat"
              required
              expanded
            />
          </div>
          <div class="column is-3">
            <parametre-autocomplete
              :label="$t('catalogue.newProduct.materielType')"
              v-model="produitDispositif.materielTypeId"
              :target="constantes.PARAMETRES_KEYS.materielType"
              required
              expanded
            />
          </div>
          <div class="column is-3">
            <qd-checkbox v-model="produitDispositif.isDoubleFace" class="mgt-10px">
              <span class="label">{{ $t("catalogue.newProduct.isDoubleFace") }}</span>
            </qd-checkbox>
          </div>
          <div class="column is-3">
            <qd-checkbox v-model="produitDispositif.materielEclaire" class="mgt-10px">
              <span class="label">{{ $t("catalogue.newProduct.eclaire") }}</span>
            </qd-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

export default {
  components: {
    ParametreAutocomplete,
  },
  props: {
    produitDispositif: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
};
</script>
